import config from '../igglo_config';
import { urlLang } from '../localization/translate';

function backendURL(path) {
  if (config.backend.port) {
    return `${config.backend.server}:${config.backend.port}${path}`;
  }

  return `${config.backend.server}${path}`;
}

function frontendURL(path) {
  return `${location.origin}${path}`;
}

export function genDownloadDepositPdfURL({ depositId, token }) {
  const path = `/api/deposit/${depositId}/pdf?jwt=${token}`;
  return backendURL(path);
}

export function genDownloadCreditCheckReportPdfURL(receiptId, token) {
  return backendURL(`/api/credit_check/report/${receiptId}/pdf?jwt=${token}`);
}

export function genAcceptDepositURL({ depositId, acceptanceId }) {
  const path = `/tenant/${urlLang}/deposit/${depositId}/accept/${acceptanceId}`;
  return frontendURL(path);
}

export function genConfirmDepositPaymentURL({ depositId, invoiceId }) {
  const path = `/tenant/${urlLang}/payment/confirm/deposit/${depositId}/${invoiceId}`;
  return frontendURL(path);
}

export function genAcceptCommissionURL({ commissionId, acceptanceId }) {
  const path = `/tenant/${urlLang}/commission/${commissionId}/accept/${acceptanceId}`;
  return frontendURL(path);
}

export function genNewCommissionURL() {
  return frontendURL(`/tenant/${urlLang}/commission/new`);
}

export function genAgentBaseURL() {
  return frontendURL(`/agent/${urlLang}/`);
}

export function genLandlordURL(path = '/') {
  return frontendURL(`/rent/${urlLang}${path}`);
}

export function genLandlordBaseURL() {
  return genLandlordURL('/');
}

export function genCreditCheckRedirectURL(path) {
  return genLandlordURL(`${path}/authentication`);
}

export function genResetPasswordLink(email, passwordToken) {
  return frontendURL(`/tenant/${urlLang}/reset_password?email=${encodeURIComponent(email)}&token=${passwordToken}`);
}
